import { app } from '../../../../app';
import { Controller } from './remote-app-access.controller';

app.component('companyManageRemoteAppAccess', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        application: '<',
        remoteApps: '<',
    },
    controller: Controller,
    templateUrl: require('./remote-app-access.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/remote-app-access/remote-app-access.component.js